export enum AvatarType {
  INDIVIDUAL = 'INDIVIDUAL',
  ORGANISATION = 'ORGANISATION',
  GROUP = 'GROUP',
  PROPOSAL = 'PROPOSAL',
  PAGE = 'PAGE',
  ALIST = 'ALIST',
}
